import { useLazyQuery, useQuery } from "@apollo/client";
import {
  ScansQuery,
  ScansQueryVariables,
} from "../../../__generated__/ScansQuery";
import { SCANS } from "../scans.queries";

export const useScans = (variables: ScansQueryVariables) => {
  console.log({ variables });
  return useQuery<ScansQuery, ScansQueryVariables>(SCANS, {
    variables,
    fetchPolicy: "network-only",
  });
};
export const useLazyScans = () => {
  return useLazyQuery<ScansQuery>(SCANS);
};
